let pos_settings_DeleteSchemeConfirm = require("../../templates/pos/settings/DeleteSchemeConfirm.handlebars");
let $ = require("jquery");
let Backbone = require("backbone");
import i18n from "../../utils/i18n";
let _ = require("underscore");
import POS from "../../POS.js";
import ModalView from "../comp/ModalView.js";
let MembershipSchemeModel = require("../../model/settings/MembershipSchemeModel.js");

let main = function () {
    var MembershipSchemeModalView = ModalView.extend({
        _confirm: function () {
            this.trigger("confirm");
        }
    });

    var MembershipQrCodeModalView = ModalView.extend({
        _confirm: function () {
            this.trigger("resetQrCode");
        }
    });

    return Backbone.View.extend({
        initialize: function () {
            this.restaurant = POS.getRestaurant();
        },

        events: {
            "click .create": "_createScheme",
            "click .delete-scheme": "_deleteScheme",
            "click .edit-scheme": "_editScheme",
            "click .qrcode": "_qrCode"
        },

        render: function () {
            var self = this;
            $.post('/pos/settings', {section: "membershipScheme"}, function (response) {
                self.$el.html(response);
                //self.setElement(self.$(".membership-schemes"));
            });
        },

        _createScheme: function (evt) {
            var that = this;
            var restaurantId = POS.getRestaurant().get('id');
            POS.showLoading(true);
            $.post("/membershipScheme/_create", {restaurantId: restaurantId}, function (response) {
                POS.showLoading(false);
                var model = new MembershipSchemeModel({"restaurantId": that.restaurant.get("id")});
                var modal = new MembershipSchemeModalView({title: i18n.msg("pos.settings.membership.createscheme")});
                modal.$el.find('.modal-content').addClass('settingsModal');
                modal.$el.find('.btn-confirm').addClass('saveCreate-btn');
                var companyId = POS.getRestaurant().get('companyId');
                modal.body(response);
                modal.render();
                modal.on("confirm", function () {
                    console.log("MODAL confirm");
                    var name = modal.$("input[name='name']").val();
                    var description = modal.$("textarea[name='description']").val();
                    var verifyCode = modal.$("input[name='verifyCode']").val();
                    var discountId = modal.$(".discountId").val();
                    model.set("name", name);
                    model.set("description", description);
                    model.set("verifyCode", verifyCode);
                    model.set("defaultDiscount.id", discountId);
                    var deferrer = model.saveScheme();
                    POS.showLoading(true);
                    deferrer.done(function (response) {
                        console.log("DONE ", response);
                        if (response.success) {
                            modal.close();
                            that.render();
//                                if (!companyId) {
//                                    console.log("NEED REFRESH to RELOAD RESTAURANT INFORMATION");
//                                    window.location.reload();
//                                }
                        } else {
                            alert(i18n.msg("pos.setting.membership.scheme.name.not.unique"));
                            modal.$("input[name='name']").focus();
                        }
                        // window.location.reload();
                    });
                    deferrer.fail(function (response) {
                        console.log("FAIL", response);
                    });
                    deferrer.always(function () {
                        POS.showLoading(false);
                    });
                });
            });
        },

        _qrCode: function (event) {
            var target = $(event.target);
            var restaurantId = target.data("restaurantid");
            var schemeId = target.data("schemeid");
            var self = this;
            self.$(".loading").show();
            POS.showLoading(true);
            $.post("/membershipScheme/_qrCode", {
                restaurantId: restaurantId,
                schemeId: schemeId
            }, function (response) {
                POS.showLoading(false);
                var modal = new MembershipQrCodeModalView({title: i18n.msg("pos.settings.membership.qrcode")});
                modal.$el.find('.modal-content').addClass('settingsModal');
                modal.$el.find('.btn-confirm').addClass('saveCreate-btn');
                modal.body(response);
                modal.confirmButtonName(i18n.msg("pos.settings.membership.generate"));
                modal.render();
                self.$(".loading").hide();
                modal.$el.find(".btn-confirm").click(function () {
                    self.$(".loading").show();
                    $.post("/membershipScheme/_qrCode", {
                        restaurantId: restaurantId,
                        schemeId: schemeId,
                        refreshQrCode: true
                    }, function (response) {
                        modal.body(response);
                        self.$(".loading").hide();
                    });
                });
            });
        },

        _deleteScheme: function (evt) {
            var self = this;
            var target = $(evt.currentTarget).closest("tr.scheme-id"), schemeId = target.data("id"), schemeName = target.data("name"), memberCount = Number(target.data("memberCount"));
            if (memberCount > 0) {
                alert("目前有" + memberCount + "张会员卡是此会员卡类别，不能删除！");
                return false;
            }
            if (schemeId) {
                var modal = new MembershipSchemeModalView();
                var model = new MembershipSchemeModel({"id": schemeId});
                var html = pos_settings_DeleteSchemeConfirm({notice: i18n.msg('pos.settings.membershipscheme.delete.confirm', schemeName)});
                modal.$el.find('.modal-content').addClass('settingsModal');
                modal.$el.find('.modal-body').css('text-align', 'center');
                modal.$el.find('.btn-confirm').addClass('saveCreate-btn');
                modal.body(html);
                modal.render();
                modal.isDeleteModal();
                modal.$el.find('.btn-confirm').removeClass('btn-danger');
                modal.on("confirm", function () {
                    var deferrer = model.deleteScheme();
                    POS.showLoading(true);
                    deferrer.done(function (response) {
                        modal.close();
                        if (response.success) {
                            self.render();
                        } else {
                            alert(response.errors);
                        }
                    });
                    deferrer.always(function (response) {
                        POS.showLoading(false);
                    });
                });
            }
        },

        _editScheme: function (evt) {
            var that = this;
            var restaurantId = POS.getRestaurant().get('id');
            var schemeId = $(evt.target).data("id");
            POS.showLoading(true);
            $.post("/membershipScheme/_edit", {id: schemeId, restaurantId: restaurantId}, function (response) {
                POS.showLoading(false);
                var modal = new MembershipSchemeModalView({title: i18n.msg("pos.settings.membership.editscheme")});
                modal.$el.find('.modal-content').addClass('settingsModal');
                modal.$el.find('.btn-confirm').addClass('saveCreate-btn');
                modal.body(response);
                modal.render();
                modal.on("confirm", function () {
                    var model = new MembershipSchemeModel({"restaurantId": that.restaurant.get("id")});
                    var name = modal.$("input[name='name']").val();
                    var description = modal.$("textarea[name='description']").val();
                    var discountId = modal.$(".discountId").val();
                    model.set("id", schemeId);
                    model.set("name", name);
                    model.set("description", description);
                    model.set("defaultDiscount.id", discountId);
                    var deferrer = model.saveScheme();
                    POS.showLoading(true);
                    deferrer.done(function (response) {
                        if (response.success) {
                            modal.close();
                            that.render();
                        } else {
                            alert(i18n.msg("pos.setting.membership.scheme.name.not.unique"));
                            modal.$("input[name='name']").focus();
                        }
                    });
                    deferrer.fail(function (response) {
                        console.log("FAIL", response);
                    });
                    deferrer.always(function (response) {
                        POS.showLoading(false);
                    });
                });
            });
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/MembershipSchemeView.js